
import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import ZohoCRMScript from "../ZohoCRMScript";

const GuideCTASection: React.FC = () => {
  return (
    <>
      <ZohoCRMScript />
      <section className="py-16 bg-[#8932c8]">
        <div className="container mx-auto px-4 md:px-6">
          <div className="max-w-3xl mx-auto text-center text-white">
            <h2 className="text-3xl font-bold mb-4">Ready to Transform Your Security Operations?</h2>
            <p className="text-lg mb-8 text-white/90">
              Experience the power of AI-driven security with Spharaka XDR™.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Dialog>
                <DialogTrigger asChild>
                  <Button size="cta" className="bg-white text-[#8932c8] hover:bg-gray-100">
                    Schedule a Demo
                  </Button>
                </DialogTrigger>
                <DialogContent className="sm:max-w-2xl max-h-[90vh] overflow-y-auto">
                  <DialogHeader>
                    <DialogTitle>Schedule a Demo</DialogTitle>
                  </DialogHeader>
                  <div id='crmWebToEntityForm' className='zcwf_lblLeft crmWebToEntityForm' style={{backgroundColor: 'white', color: 'black', maxWidth: '600px'}}>
                    <form id='webform966770000000572001' action='https://crm.zoho.in/crm/WebToLeadForm' name='WebToLeads966770000000572001' method='POST' onSubmit={() => { return (window as any).checkMandatory966770000000572001(); }} acceptCharset='UTF-8'>
                      <input type='text' style={{display:'none'}} name='xnQsjsdp' value='2eaa648798ce23a7a9a9fdfb797621a05074c8311ce9031824d1b4d79807096f' />
                      <input type='hidden' name='zc_gad' id='zc_gad' value='' />
                      <input type='text' style={{display:'none'}} name='xmIwtLD' value='3b367f412ccfde6c347aca9059e7efedf4cd6eef72f9a51d2beb75a4850be285503386a2c820cee984c68e0e4df8b7e1' />
                      <input type='text' style={{display:'none'}} name='actionType' value='TGVhZHM=' />
                      <input type='text' style={{display:'none'}} name='returnURL' value='null' />
                      
                      <div className='zcwf_row'>
                        <div className='zcwf_col_lab' style={{fontSize:'12px', fontFamily: 'Arial'}}>
                          <label htmlFor='First_Name'>First Name <span style={{color:'red'}}>*</span></label>
                        </div>
                        <div className='zcwf_col_fld'>
                          <input type='text' id='First_Name' aria-required='true' aria-label='First Name' name='First Name' maxLength={40} />
                        </div>
                      </div>
                      
                      <div className='zcwf_row'>
                        <div className='zcwf_col_lab' style={{fontSize:'12px', fontFamily: 'Arial'}}>
                          <label htmlFor='Last_Name'>Last Name <span style={{color:'red'}}>*</span></label>
                        </div>
                        <div className='zcwf_col_fld'>
                          <input type='text' id='Last_Name' aria-required='true' aria-label='Last Name' name='Last Name' maxLength={80} />
                        </div>
                      </div>
                      
                      <div className='zcwf_row'>
                        <div className='zcwf_col_lab' style={{fontSize:'12px', fontFamily: 'Arial'}}>
                          <label htmlFor='Email'>Work Email <span style={{color:'red'}}>*</span></label>
                        </div>
                        <div className='zcwf_col_fld'>
                          <input type='text' data-ftype='email' autoComplete='false' id='Email' aria-required='true' aria-label='Email' name='Email' maxLength={100} />
                        </div>
                      </div>
                      
                      <div className='zcwf_row'>
                        <div className='zcwf_col_lab' style={{fontSize:'12px', fontFamily: 'Arial'}}>
                          <label htmlFor='Company'>Company <span style={{color:'red'}}>*</span></label>
                        </div>
                        <div className='zcwf_col_fld'>
                          <input type='text' id='Company' aria-required='true' aria-label='Company' name='Company' maxLength={200} />
                        </div>
                      </div>
                      
                      <div className='zcwf_row'>
                        <div className='zcwf_col_lab' style={{fontSize:'12px', fontFamily: 'Arial'}}>
                          <label htmlFor='Description'>How can we help? <span style={{color:'red'}}>*</span></label>
                        </div>
                        <div className='zcwf_col_fld'>
                          <textarea style={{fontFamily: 'Arial, sans-serif'}} id='Description' aria-required='true' aria-label='Description' name='Description'></textarea>
                        </div>
                      </div>
                      
                      <div className='zcwf_row'>
                        <div className='zcwf_col_lab'></div>
                        <div className='zcwf_col_fld'>
                          <div style={{display: 'flex', alignItems: 'flex-start', marginBottom: '10px'}}>
                            <input type='checkbox' id='privacyConsent1' required style={{marginRight: '8px', marginTop: '2px'}} />
                            <label htmlFor='privacyConsent1' style={{fontSize: '12px', color: '#666', lineHeight: '1.4'}}>
                              I agree to the{" "}
                              <a href='/privacy-policy' target='_blank' style={{color: '#8932c8', textDecoration: 'underline'}}>
                                Privacy Policy
                              </a>{" "}
                              and consent to the processing of my personal data. <span style={{color: 'red'}}>*</span>
                            </label>
                          </div>
                        </div>
                      </div>
                      
                      <input type='text' style={{display: 'none'}} name='aG9uZXlwb3Q' value='' />
                      
                      <div className='zcwf_row'>
                        <div className='zcwf_col_lab'></div>
                        <div className='zcwf_col_fld'>
                          <input type='submit' id='formsubmit' className='formsubmit zcwf_button' value='Submit' style={{backgroundColor: '#8932c8', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '4px', cursor: 'pointer'}} />
                          <input type='reset' className='zcwf_button' name='reset' value='Reset' style={{marginLeft: '10px', padding: '10px 20px', borderRadius: '4px', cursor: 'pointer'}} />
                        </div>
                      </div>
                    </form>
                  </div>
                </DialogContent>
              </Dialog>
              <Button asChild size="cta" variant="outline" className="border-white text-white hover:bg-white/20">
                <Link to="/products/spharakaxdr">Explore the Platform</Link>
              </Button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default GuideCTASection;
